var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;

/**
  * @function evaluate - evaluate metaTagFieldOptionsBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const sourceEvaluator = newSource => evaluateSource(newSource, content, parentContentPath, transientContext, nativeFunctions);
  const cacheKey = await sourceEvaluator(source.name);
  if (cacheKey === undefined) {
    return {};
  }
  const metaTagOptions = await sourceEvaluator({
    type: 'getCacheValueBehavior',
    name: cacheKey
  });
  const formTypeIdentifier = await sourceEvaluator(source.formTypeIdentifier);
  if (formTypeIdentifier === undefined) {
    return {};
  }
  if (metaTagOptions === null) {
    return {};
  }
  const _Object$keys = Object.keys(formTypeIdentifier),
    _Object$keys2 = _slicedToArray(_Object$keys, 1),
    formTypeIdentifierKey = _Object$keys2[0];
  const _metaTagOptions$formT = metaTagOptions[formTypeIdentifierKey].children,
    children = _metaTagOptions$formT === void 0 ? {} : _metaTagOptions$formT;
  return children;
};
module.exports = {
  evaluate
};